import { useState, type ButtonHTMLAttributes, type ReactNode } from "react";
import { ReceiptUploadDialog } from "./ReceiptUploadDialog";

interface ReceiptUploadButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  linkedExpenseId?: string;
  linkedInvoiceId?: string;
  children?: ReactNode;
}

export function ReceiptUploadButton({
  linkedExpenseId,
  linkedInvoiceId,
  children,
  onClick,
  ...buttonProps
}: ReceiptUploadButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        {...buttonProps}
        onClick={(e) => {
          onClick?.(e);
          if (!e.defaultPrevented) setOpen(true);
        }}
      >
        {children}
      </button>
      <ReceiptUploadDialog
        open={open}
        onOpenChange={setOpen}
        linkedExpenseId={linkedExpenseId}
        linkedInvoiceId={linkedInvoiceId}
      />
    </>
  );
}
